import { render, staticRenderFns } from "./LoaderPlane.vue?vue&type=template&id=72426b1d&scoped=true&"
import script from "./LoaderPlane.vue?vue&type=script&lang=js&"
export * from "./LoaderPlane.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPlane.vue?vue&type=style&index=0&id=72426b1d&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72426b1d",
  null
  
)

export default component.exports